import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core";

export default function EligibilityStaticDateFilter(props) {
   const {
      handleFilterChange,
      value,
      disabled,
      theme,
      LANGUAGE_TEXT,
      accountState,
   } = props;

   const materialTheme = createMuiTheme({
      palette: {
         primary: {
            main: theme.primaryColor,
         },
         secondary: {
            main: theme.primaryColor,
         },
      },
      overrides: {
         MuiTypography: {
            body1: {
               fontFamily: "Avenir",
               fontSize: 16,
            },
            h5: {
               fontFamily: "Avenir",
               fontSize: "16px",
               fontWeight: "lighter",
            },
         },
         MuiFormControlLabel: {
            label: {
               color: theme.textColorPrimary,
            },
         },
      },
   });

   return (
      <ThemeProvider theme={materialTheme}>
         <Typography variant="h5" tabIndex="0">
            {accountState?.conditionSpecificBehaviors?.translateText &&
            accountState?.storeInfo?.languageCode
               ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                    ?.appointment_filter_text
               : "Filter appointments by start time:"}
         </Typography>
         <FormControl component="fieldset">
            <RadioGroup
               row
               value={value || "all"}
               name="timePeriod"
               aria-label="timePeriod"
               onChange={(event) => handleFilterChange(event.target.value)}
            >
               <FormControlLabel
                  value="all"
                  control={<Radio />}
                  label={
                     accountState?.conditionSpecificBehaviors?.translateText &&
                     accountState?.storeInfo?.languageCode
                        ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                             ?.anytime
                        : "Anytime"
                  }
                  disabled={disabled}
               />
               <FormControlLabel
                  value="am"
                  control={<Radio />}
                  label={
                     accountState?.conditionSpecificBehaviors?.translateText &&
                     accountState?.storeInfo?.languageCode
                        ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                             ?.morning
                        : "Morning"
                  }
                  disabled={disabled}
               />
               <FormControlLabel
                  value="pm"
                  control={<Radio />}
                  label={
                     accountState?.conditionSpecificBehaviors?.translateText &&
                     accountState?.storeInfo?.languageCode
                        ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                             ?.afternoon
                        : "Afternoon"
                  }
                  disabled={disabled}
               />
            </RadioGroup>
         </FormControl>
      </ThemeProvider>
   );
}
